<template>
  <page title="Support Tickets">
    <div class="box">
      <b-table
        class="is-middle"
        :loading="tickets.loading"
        :data="tickets.data"
        :current-page="tickets.current_page"
        :per-page="tickets.per_page"
        :total="tickets.total"
        @page-change="
          page => {
            tickets.changePage(page);
          }
        "
        paginated
        backend-pagination
        pagination-position="bottom"
      >
        <template slot-scope="props">
          <b-table-column label="#">
            <router-link :to="'/support/tickets/' + props.row.id">{{ props.row.id }}</router-link>
          </b-table-column>

          <b-table-column label="Хүсэлт">
            <span class="has-text-grey">{{ props.row.title }}</span>
          </b-table-column>

          <b-table-column label="User">
            <router-link :to="'/users/' + props.row.user.id">
              <div class="has-text-grey" style="display: inline-flex; align-items: center;">
                <div class="image is-32x32 mr-4">
                  <img :src="props.row.user.profile_picture.sm" class="is-rounded" />
                </div>

                <span>{{ props.row.user.email }}</span>
              </div>
            </router-link>
          </b-table-column>

          <b-table-column label="State" centered>
            <ticket-status :status="props.row.status"></ticket-status>
          </b-table-column>

          <b-table-column label="Сүүлд" width="350">
            <div style="max-width: 350px;">
              <div
                class="has-text-grey"
                style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"
                v-if="props.row.latest_reply"
              >
                <span
                  v-if="props.row.latest_reply.user_type === 'officer'"
                  class="has-text-grey has-text-weight-bold"
                >M+ ({{ props.row.latest_reply.user.name }}):</span>

                <span
                  v-if="props.row.latest_reply.user_type === 'customer'"
                  class="has-text-weight-bold"
                  :class="{
                    'has-text-danger': props.row.status === 'open'
                  }"
                >User:</span>
                {{ props.row.latest_reply.body }}
              </div>
            </div>
          </b-table-column>

          <b-table-column label="Date" centered>
            <span class="has-text-grey">{{ props.row.created_at }}</span>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
              <p>No result.</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
import TicketStatus from "./../../../../../components/TicketStatus";

export default {
  components: {
    TicketStatus
  },

  data() {
    return {
      tickets: new window.PaginatedRemoteCollection(
        "/admin/api/support/tickets"
      ).load()
    };
  }
};
</script>
